import { render } from "./additionalProperties.vue?vue&type=template&id=7382a0c1&scoped=true&ts=true"
import script from "./additionalProperties.vue?vue&type=script&lang=ts"
export * from "./additionalProperties.vue?vue&type=script&lang=ts"

import "./additionalProperties.vue?vue&type=style&index=0&id=7382a0c1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7382a0c1"]])

export default __exports__